import React from 'react';
import { useLocalizedStrings } from '../../Localization';
import { Button,  Heading,  Icon,  NumberDisplay } from '@aidkitorg/component-library';
import { usePayments } from '../../Contexts/PaymentsContext';
import { PaymentsDataTable } from './components/PaymentsDataTable';
import { generateTimestampString } from '../../utils/adminPanel.utils';
import { AdminPanelPage } from '../AdminPanelPage';

export const PaymentsPage = () => {
  const L = useLocalizedStrings()

  const {
    fetchPaymentsOverview, 
    enabledPayments, 
    paymentsDataTimestamp,

    isPaymentsLoading
  } = usePayments();

  const enabledPaymentsCard = <NumberDisplay
    loading={isPaymentsLoading}
    className="max-w-56"
    title={L.admin_panel.payments.enabled_payments}
    value={enabledPayments} 
    unit={L.admin_panel.payments.payments}
    unitSingular={L.admin_panel.payments.payment}
    iconName="PlayCircleIcon" 
    iconColor="blue"
  />

  const lastUpdated = (
    <div className="flex gap-2 items-center text-gray-700">
      {paymentsDataTimestamp && (
        <div className="flex gap-1 items-center">
          <div>
            <Icon role="decorative" name="ClockIcon"/>
          </div>
          <div>
            {L.admin_panel.payments.last_updated}: {generateTimestampString(paymentsDataTimestamp)}
          </div>
        </div>
      )}
      <div>
        <Button 
          icon={<Icon role="decorative" name="ArrowPathIcon" />} 
          variant="unstyled" size="sm" 
          aria-label="Refresh data"
          onClick={async () => {
            await fetchPaymentsOverview(true)
          }}
        />
      </div>
    </div>
  )
  
  const headerContent = (
    <>
      <div>
        <Heading level="h1" className="m-0">{L.admin_panel.nav.payments}</Heading>
        <div className="text-lg text-gray-700">{L.admin_panel.payments.payments_about}</div>
      </div>
      <div>
        {lastUpdated}
      </div>
    </>
  )
  
  return (
    <AdminPanelPage
      headerContent={headerContent}
    >
      <div className="flex flex-col gap-4">
        <div>
          {enabledPaymentsCard}
        </div>
        <div>
          <div className="border rounded-md p-4 bg-white">
            <PaymentsDataTable />
          </div>
        </div>
      </div>
    </AdminPanelPage>
  )
}